import { normalizeSortString } from "../../../lib/helpers/normalizeString";
import { StructureTableColumn } from "./StructureTable";

export type SortDirection = "asc" | "desc";

const getNestedValue = (obj: any, path: string): any => {
  return path.split(".").reduce((current, key) => current?.[key], obj);
};

const compareValues = (a: any, b: any) => {
  if (typeof a === "string" && typeof b === "string") {
    return normalizeSortString(a).localeCompare(normalizeSortString(b));
  }

  const aNum = Number(a);
  const bNum = Number(b);

  if (!isNaN(aNum) && !isNaN(bNum)) {
    if (aNum < bNum) return -1;
    if (aNum > bNum) return 1;
    return 0;
  }

  return normalizeSortString(String(a ?? "")).localeCompare(
    normalizeSortString(String(b ?? ""))
  );
};

export const sortStructureTableData = <T,>(
  data: T[],
  columns: StructureTableColumn[],
  columnKey: string,
  direction: SortDirection
): T[] => {
  if (!columnKey) {
    return data;
  }

  const sortColumn = columns.find((col) => col.key === columnKey);
  const sortPath = sortColumn?.sortKey || columnKey;

  return [...data].sort((first, second) => {
    const firstValue = getNestedValue(first, sortPath);
    const secondValue = getNestedValue(second, sortPath);

    const comparison = compareValues(firstValue, secondValue);

    return direction === "asc" ? comparison : comparison * -1;
  });
};
